import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['wrapper', 'input', 'helper', 'label', 'icon'];
  static values = {
    readonly: { type: Boolean, default: false }
  }

  connect() {
    this.inputTarget.addEventListener('focus', this.focus.bind(this))
    this.inputTarget.addEventListener('blur', this.blur.bind(this))

    const hasError = this.inputTarget.dataset.hasError === 'true';
    if (hasError) this.showError();

    this.readonlyValueChanged()
  }

  disconnect() {
    this.inputTarget.removeEventListener('focus', this.focus.bind(this))
    this.inputTarget.removeEventListener('blur', this.blur.bind(this))
  }

  readonlyValueChanged() {
    if (this.readonlyValue) {
      this.applyReadonlyStyles()
    } else {
      this.removeReadonlyStyles()
    }
  }

  applyReadonlyStyles() {
    if (this.hasWrapperTarget) {
      this.wrapperTarget.classList.add('cursor-not-allowed')
      this.wrapperTarget.classList.remove('cursor-pointer')
    }

    this.inputTarget.classList.add('bg-black-200', '!cursor-not-allowed',
      '!pointer-events-none', 'checked:!bg-black-200', 'checked:!border-black-200')

    if (this.inputTarget.checked && this.hasIconTarget) {
      this.iconTarget.classList.remove('hidden')
      this.iconTarget.classList.add('!block', 'text-black-400')
    }
    if (this.hasLabelTarget) { this.labelTarget.classList.add('!text-black-400') }
    if (this.hasHelperTarget) { this.helperTarget.classList.add('!text-black-400') }
  }

  removeReadonlyStyles() {
    if (this.hasWrapperTarget) {
      this.wrapperTarget.classList.remove('cursor-not-allowed')
      this.wrapperTarget.classList.add('cursor-pointer')
    }

    this.inputTarget.classList.remove('bg-black-200', '!cursor-not-allowed',
      '!pointer-events-none', 'checked:!bg-black-200', 'checked:!border-black-200')

    if (this.inputTarget.checked && this.hasIconTarget) {
      this.iconTarget.classList.add('hidden')
      this.iconTarget.classList.remove('!block', 'text-black-400')
    }
    if (this.hasLabelTarget) { this.labelTarget.classList.remove('!text-black-400') }
    if (this.hasHelperTarget) { this.helperTarget.classList.remove('!text-black-400') }
  }

  showError() {
    this.inputTarget.classList.add(
      'border-red-300',
      'checked:border-red-1000',
      'checked:hover:border-red-1000',
    );
    this.inputTarget.classList.add('bg-red-100', 'checked:bg-red-1000');

    if (this.hasHelperTarget) {
      this.helperTarget.classList.add('text-red-1000');
    }

    if (this.hasLabelTarget) {
      this.labelTarget.classList.add('text-red-1000');
    }
  }

  focus() {
    this.inputTarget.classList.add(
      'ring-2',
      'ring-black-100',
      'ring-offset-2',
      'ring-offset-white',
    );
  }

  blur() {
    this.inputTarget.classList.remove(
      'ring-2',
      'ring-black-100',
      'ring-offset-2',
      'ring-offset-white',
    );
  }
}
